<template>
    <div class="printManagementDialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="800px">
            <div class="dialogBox">
                <div class="details">
                    <div class="detailsItem">
                        <h3>基础信息</h3>
                        <div class="itemContent">
                            <div class="two-row">
                                <div class="label">需求名称:</div>
                                <div class="name">{{ form.title }}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">咨询企业名称:</div>
                                <div class="name">{{ form.enterpriseName }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">联系人:</div>
                                <div class="name">{{ form.contactName }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">联系电话:</div>
                                <div class="name">{{ form.phone }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">处理状态:</div>
                                <div class="name">{{ form.result=='NONE'?'未处理':'已处理' }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">处理日期:</div>
                                <div class="name">{{ form.completeTime }}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">需求详情:</div>
                                <div class="name">{{ form.content }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="detailsItem" v-show="form.fileList.length > 0" >
                        <h3>文件名称</h3>
                        <div class="itemContent">
                            <div class="two-row" v-for="(item,index) in form.fileList" style="margin-bottom: 15px;">
                                <div class="content">
                                    <div class="area">
                                        <span @click="download(item.filePath,item.fileName)">{{item.fileName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { findSolutionConsult } from '../../utils/solutionConsult';

    export default {
        name: "solutionConsultDialog",
        data() {
            return {
                dialogVisible: false,
                title: '详情',
                form: {},
            }
        },
        methods: {
            init(uuid) {
                this.dialogVisible = true;
                this.form = {};
                findSolutionConsult(uuid).then((res)=>{
                    this.form = res;
                });
            },
            download(filePath,fileName){
                const x = new window.XMLHttpRequest();
                x.open('GET', filePath, true);
                x.responseType = 'blob';
                x.onload = () => {
                    const url = window.URL.createObjectURL(x.response);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    a.click();
                };
                x.send();
            }
        }
    }
</script>

<style scoped lang="less">
 //审核查看详情中title的样式
/deep/.el-dialog__header{
    border-bottom: 1px solid #ddd;
   .el-dialog__title{
    color: #000;
    font-weight: 700;
    font-size: 16px;
    
  }
}
    .dialogBox{
        padding-top: 20px;
        .details{
            .detailsItem{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                }
                .itemContent{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    // padding: 0 30px;
                    .one-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label{
                            padding-right: 15px;
                            min-width: 110px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name{
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                        }
                    }
                    .two-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label{
                            padding-right: 15px;
                            min-width: 110px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name{
                            // color: #000;
                            caret-color: rgba(0, 0, 0, 0.65);
                        }
                    }
                }
            }
            .area{
                span{
                    color: #3d7fff;
                    cursor: pointer;
                    &:hover{
                        text-decoration: underline;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/solutionConsult/solutionConsultDetail.vue